// Istanzio secondo hook form per gestione editing dettaglio richiesta
import {useForm} from "react-hook-form";
import {PresenzeCausaleWFRecord} from "@commons/mapping/PresenzeCausaleWF";
import React, {useEffect} from "react";
import {ModalPanelForm} from "@components/Modal2023";
import DashboardDetailWF from "../dashboardWF/wf.dashboard.detail";
import {usePutSingolaRichiestaWF, useSingolaRichiestaWF} from "@commons/services/presenze_api/dashboard.queries";
import {Periodo} from "@commons/types";
import {toast} from "react-toastify";
import BannerWF from "../dashboardWF/comps/BannerWF";
import {LavoratoreBase} from "@commons/mapping/LavoratoreBase";
import {useQueryClient} from "@tanstack/react-query";
import {FPNetDate} from "@commons/types";

interface DeleteWFProps {
    URI: string,
    periodo: Periodo,
    onCancelEdit: () => void,

    lavoratore: LavoratoreBase,
    onSaveSuccess?: (richiestaWF: PresenzeCausaleWFRecord) => void,
    isEditabile: (currentDay: FPNetDate) => boolean, //Se page è MONITOR WF, testo per ogni richiesta se editabile o meno!

}

export const DeleteWF: React.FC<DeleteWFProps> = ({
                                                      URI, periodo, onCancelEdit,
                                                      lavoratore,
                                                      onSaveSuccess = (richiestaWF: PresenzeCausaleWFRecord) => {
                                                      },
                                                      isEditabile
                                                  }) => {
    const queryClient = useQueryClient();
    const singolaRichiesta = useSingolaRichiestaWF(URI);
    const mutation = usePutSingolaRichiestaWF(URI);

    const saveResource = (causale: PresenzeCausaleWFRecord) => {
        mutation.mutateAsync(causale).then(({data: richiestaWFAggiornata}) => {
            toast('Richiesta aggiornata!', {type: 'success'});
            onSaveSuccess({...causale, ...richiestaWFAggiornata});
        });
    };

    const onCancelEditLocal = () => {
        queryClient.invalidateQueries({queryKey: ["singolaRichiestaWF", URI]}); // scarico cache alla chiusura del form

        if (onCancelEdit)
            onCancelEdit();
    }

    const hookForm = useForm<PresenzeCausaleWFRecord>({mode: 'onChange', reValidateMode: 'onChange'});
    const {reset: resetAsyncForm, control, setValue} = hookForm;
    useEffect(() => {
        // Come da documentazione https://react-hook-form.com/docs/useform/reset
        // values object An optional object to reset form values, and it's recommended to provide the entire defaultValues when supplied.
        resetAsyncForm({...PresenzeCausaleWFRecord.factory(), ...singolaRichiesta.data});
        setValue('wf.annullata', true);
    }, [setValue, resetAsyncForm, singolaRichiesta.data])

    return <>{singolaRichiesta.data &&

        <ModalPanelForm isOpen={!!singolaRichiesta.data} formControl={control} handleDismiss={onCancelEdit}
                        header={<BannerWF richiesta={singolaRichiesta.data} lavoratore={lavoratore} ope="DELETE"/>}>

            <DashboardDetailWF
                hook={hookForm}
                richiesta={singolaRichiesta.data} periodo={periodo}
                deleteRichiesta={true}
                hhPreviste={null}
                hhWeekMedie={0}
                hhMancanti={0}
                onCancel={onCancelEditLocal}
                onSave={saveResource}
                page="WF"
                lavoratore={lavoratore}
                isEditabile={isEditabile(singolaRichiesta.data.giornoDt)}
            />

        </ModalPanelForm>}
    </>
}
export default DeleteWF;